import {Component, EventEmitter, Inject, Input, OnInit, Output,} from '@angular/core';
import {Observable} from 'rxjs';
import {FileResponse} from '../../../../models/file.response';
import {saveAs} from 'file-saver';
import {SuppliersService} from '../../../../services/suppliers.service';
import {ActivatedRoute} from '@angular/router';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {UploadInspectionReportComponent} from './upload-inspection-report/upload-inspection-report.component';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {CoreService, DocumentService, ImageService, ProleisObject, RequestParam} from "@proleis/proleis-rest-client";
import {LoadingService, NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-position-pm-card',
  templateUrl: 'position.card.pm.component.html',
  styleUrls: ['position.card.pm.component.scss'],
})
export class PositionCardPmComponent implements OnInit {
  @Input() pos: ProleisObject;
  @Input() pbo: ProleisObject;
  @Output() posUpdatedEvent: EventEmitter<string> = new EventEmitter<string>();
  icons: Observable<Map<string, string>>;
  editContacts = false;
  selectedPlanner: ProleisObject;
  selectedMetrologist: ProleisObject;
  planners$: Observable<ProleisObject[]>;
  metrologists$: Observable<ProleisObject[]>;

  constructor(
    private cs: CoreService,
    private is: ImageService,
    private ds: DocumentService,
    private ls: LoadingService,
    private supplierService: SuppliersService,
    private route: ActivatedRoute,
    private bs: MatBottomSheet,
    @Inject(APP_GUIDS) private guids: AppGuids,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    const identifiers =
      this.pos.PMICON +
      ',' +
      this.pos.PMGROUPICON +
      ',' +
      this.pos.PMSTATUSICON;
    this.icons = this.is.getIconUrls(identifiers);
    this.loadContacts();
  }

  loadContacts() {
    this.metrologists$ = this.supplierService.getPmContactExtMetrologists(
      this.route.snapshot.params.id,
      this.pos.OBJECT_ID,
    );
    this.planners$ = this.supplierService.getPmContactExtPlanners(
      this.route.snapshot.params.id,
      this.pos.OBJECT_ID,
    );
  }

  uploadInspectionReport() {
    this.bs
      .open(UploadInspectionReportComponent)
      .afterDismissed()
      .subscribe((result) => {
        const formData: FormData = new FormData();
        formData.set('file', result.item(0), result.item(0).name);
        this.cs
          .executeActionFormData(
            this.pos.OBJECT_ID,
            '§' + this.guids.GUID_UPLOAD_INSPECTION_REPORT,
            formData,
            '1474',
          )
          .subscribe((result) => {
            this.notificationService.showNotification(
              'Prüfbericht hochgeladen',
            );
            this.posUpdatedEvent.emit();
          });
      });
  }

  downloadReport(objectId: string, exportType: string) {
    const param: RequestParam = {
      DOCUEXPORT_TYPE: exportType,
      PATH_ID: '1474',
    };
    //SCRIPT_PBOPOS_PM_CREATE_DOCUEXPORT
    const actionId = '§0d1c24a2-2d39-11b2-8095-ab4c4d9dd252';
    this.ls.setBlocking('CREATING_DOC', true, 'Erstelle Dokument...');
    this.cs
      .executeAction<ProleisObject>(objectId, actionId, param)
      .subscribe((response) => {
        this.ls.setBlocking('CREATING_DOC', false, '');
        if (response) {
          this.ds.getDocumentFile(response.value).subscribe((response) => {
            const fileResponse: FileResponse =
              FileResponse.parseResponse(response);
            saveAs(fileResponse.content, fileResponse.fileName);
          });
        }
      });
  }

  toggleEditContacts() {
    this.editContacts = !this.editContacts;
  }

  saveContacts() {
    this.supplierService
      .updatePmContacts(this.pbo.OBJECT_ID, this.pos.OBJECT_ID, {
        extMetrologistId: this.selectedMetrologist?.OBJECT_ID,
        extPlannerId: this.selectedPlanner?.OBJECT_ID,
      })
      .subscribe((result) => {
        this.editContacts = false;
        this.posUpdatedEvent.emit(this.pos.OBJECT_ID);
      });
  }
}
